import { cn } from '@/lib/utils'

interface SegmentedProps<T extends string> {
  options: readonly T[]
  value: T
  onChange: (value: T) => void
  size?: 'sm' | 'md'
  ariaLabel?: string
}

/** Pill toggle matching the dashboard's segmented controls. */
export function Segmented<T extends string>({ options, value, onChange, size = 'md', ariaLabel }: SegmentedProps<T>) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className="inline-flex items-center gap-0.5 rounded-full bg-stone-100 p-0.5 dark:bg-stone-800/70"
    >
      {options.map((opt) => {
        const active = opt === value
        return (
          <button
            key={opt}
            role="tab"
            type="button"
            aria-selected={active}
            onClick={() => onChange(opt)}
            className={cn(
              'whitespace-nowrap rounded-full font-medium transition-colors',
              size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm',
              active
                ? 'bg-white text-stone-900 shadow-sm ring-1 ring-stone-900/5 dark:bg-stone-950 dark:text-white'
                : 'text-stone-500 hover:text-stone-900 dark:text-stone-400 dark:hover:text-stone-100',
            )}
          >
            {opt}
          </button>
        )
      })}
    </div>
  )
}
